import type { ILocation } from '../../../../models/location';
import { LocationType } from '../../../../models/location-type.enum';

export class LocationApiModel {
  private static parseLocationType(value: string): LocationType {
    return value as LocationType;
  }

  public static mapToBusinessModel(apiModel: LocationApiModel): ILocation {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      locationType: LocationApiModel.parseLocationType(apiModel.locationType),
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      platform: apiModel.platform,
      hasLocalService: apiModel.hasLocalService ?? false,
    };
  }

  public gid: string | undefined;
  public name: string | undefined;
  public locationType!: string;
  public latitude?: number;
  public longitude?: number;
  public platform?: string;
  public straightLineDistanceInMeters?: number;
  public hasLocalService: boolean | undefined;
}

export const UNDEFINED_LOCATION: LocationApiModel = {
  gid: undefined,
  name: undefined,
  locationType: 'unknown',
  latitude: undefined,
  longitude: undefined,
  platform: undefined,
  straightLineDistanceInMeters: undefined,
  hasLocalService: false,
};
